import { FC, useEffect } from 'react';
import { ActivityV3, SubscriptionV3 } from '#types';
import { formatBytes, formatDate, formatDateWithHours } from '../../services/helpers';
import { useAppContext, useSafeState } from '#hooks';
import { dashboardApiV3 } from '#api';

interface SubscriptionToDisplayProps {
    subscription: SubscriptionV3
}

export const SubscriptionToDisplayV3: FC<SubscriptionToDisplayProps> = ({ subscription }) => {

    const { setApiStatus } = useAppContext();
    const [activity, setActivity] = useSafeState<ActivityV3>({} as ActivityV3);
    const [isLoading, setIsLoading] = useSafeState<boolean>(true);

    useEffect(
        () => {
            const fetchActivity = async () => {
                setIsLoading(true);
                try {
                    const response = await dashboardApiV3.fetchActivity(subscription.nanoID);
                    setActivity(response.data);
                } catch (error: any) {
                    setApiStatus({ code: error?.response?.data?.statusCode, message: error?.response?.data?.message })
                } finally {
                    setIsLoading(false);
                }
            };

            fetchActivity();
        },
        []
    );

    if (isLoading) {
        return <div className="lds-hourglass" />
    }

    return <div
        style={{ padding: 15, width: 320, display: 'flex', flexDirection: 'column' }}
        key={subscription.nanoID}
        className='a-tag-reset faq-li center-wrapper border-radius-s line-height'
    >
        {subscription.plan?.name && <h3 className='bold selectable-text mb-m'>{subscription.plan.name}</h3>}
        <ul>
            {
                subscription.createdAt && <li>
                    <div>Date bought: <span className='bold'>{formatDate(subscription.createdAt)}</span></div>
                </li>
            }
            {
                subscription.order?.status && <li>
                    <div>Order Status: <span className='bold'>{subscription.order.status.toUpperCase()}</span></div>
                </li>
            }
            <li>
                <div className='selectable-text'>Subscription Status: <span className='bold selectable-text'>{subscription.status.toUpperCase()}</span></div>
            </li>
            {/* <li>
                <div className='selectable-text'>Activation Date: <span className='bold selectable-text'>{subscription.activationDate === " " ? "Not activated yet" : activationDate}</span></div>
            </li> */}
            <li>
                <div className='selectable-text'>ID: {subscription.nanoID}</div>
            </li>
            {
                subscription?.expirationDate && <li>
                    <div className='selectable-text'>Expires On: <span className='bold selectable-text'>{formatDate(subscription?.expirationDate)}</span></div>
                </li>
            }
            {
                activity && activity.initialBalanceBytes > 0 && <li>
                    <div>
                        Data:
                        <progress
                            value={(activity.currentBalanceBytes / activity.initialBalanceBytes) * 100}
                            max={100}
                            className='ml-s progress-bar'
                        />
                        <span className='ml-s'>{formatBytes(activity.currentBalanceBytes)}</span>
                    </div>
                    {activity.lastUpdatedAt && <p>Checked at: <span className='bold'>{formatDateWithHours(new Date(activity.lastUpdatedAt))}</span></p>}
                </li>
            }
        </ul>
    </div>
}